<template>
  <div class="pb-1">
    <v-card width="400px" title>
      <v-card-title class="subtitle-2"> Commisions </v-card-title>
      <v-divider></v-divider>
      <template v-for="(item, i) in list">
        <v-list-item :key="i">
          <v-list-item-avatar>
            <image-view :src="getImage(item)"></image-view>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.ServiceName }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            {{ item.Flat == "True" ? `Rs ${item.Offer}` : `${item.Offer}%` }}
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="'divider-' + i"></v-divider>
      </template>
    </v-card>
  </div>
</template>

<script>
import { getURL } from "../../../assets/js/common";
import ImageView from "../../ImageView.vue";
export default {
  components: { ImageView },
  props: {
    type: String,
  },
  computed: {
    list() {
      let { Commission } = this.$store.getters.dashboard;
      let item = null;
      if (Commission instanceof Array) {
        item = Commission.find((item) => {
          return item.SeviceType == this.type;
        });
      }
      return item instanceof Object ? item.data : [];
    },
  },
  methods: {
    getImage({ Circle_img_path }) {
      return getURL(Circle_img_path);
    },
  },
};
</script>

<style>
</style>